import { useEffect } from 'react';

type KeyboardHandler = () => void;

type KeyboardShortcut = {
  key: string;
  ctrl?: boolean;
  meta?: boolean;
  handler: KeyboardHandler;
};

export const useKeyboardShortcuts = (
  shortcuts: KeyboardShortcut[],
  disabledSelectors: string[] = ['input', 'textarea', '[contenteditable="true"]']
) => {
  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      // Check if target is in disabled selectors
      const target = e.target as HTMLElement;
      if (disabledSelectors.some(selector =>
        target.matches(selector) ||
        target.closest(selector)
      )) {
        return;
      }

      // Find matching shortcut
      const shortcut = shortcuts.find(s =>
        s.key === e.key &&
        !!s.ctrl === e.ctrlKey &&
        !!s.meta === e.metaKey
      );

      if (shortcut) {
        e.preventDefault();
        shortcut.handler();
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [shortcuts, disabledSelectors]);
};
